import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useChatApi } from "../useChatApi";

export function useChatUpdateSystemConversation(
  options?: UseMutationOptions<
    AxiosResponse<unknown>,
    unknown,
    [number, string, string, string | undefined, string[]]
  >
) {
  const api = useChatApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((vars) => api.updateSystemConversation(...vars), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries(["chat-conversations"]);
    },
    ...rest,
  });
}
